import { testimonials } from '@/mocks/motionComics';

const pillars = [
  { icon: 'ri-compass-3-fill', title: '网站定位', desc: '专注韩国动态漫画的在线播放平台，把全彩、有声、特效、配音的好作品一站式带给追更党。' },
  { icon: 'ri-lightbulb-fill', title: '发展理念', desc: '让阅读更沉浸、让追更更简单。不断优化播放流畅度与更新速度，陪伴每一位读者一路追到底。' },
  { icon: 'ri-shield-check-fill', title: '内容原则', desc: '坚持正版合作、同步更新与内容品质把关，只推荐值得花时间的全彩动态漫画，杜绝粗制滥造。' },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium tracking-widest text-primary-400">ABOUT HANMOTION</span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">关于我们 · 口碑来自每一份认真</h2>
          <p className="mt-4 text-sm leading-7 text-foreground-300">
            韩漫映画是一个为动态漫画爱好者而生的在线平台。我们用更快的更新、更稳的播放和更贴心的体验，陪你追完每一部好作品。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {pillars.map((p) => (
            <div key={p.title} className="card-lift rounded-lg border border-background-300/50 bg-background-50 p-5 md:p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-50">{p.title}</h3>
              <p className="mt-2 text-xs leading-6 text-foreground-300 md:text-sm md:leading-7">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {testimonials.map((t) => (
            <figure key={t.name} className="card-lift rounded-lg border border-background-300/50 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-1 text-accent-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-xs leading-6 text-foreground-200 md:text-sm md:leading-7">
                “{t.content}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-background-950">
                  {t.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-50">{t.name}</span>
                  <span className="block text-[11px] text-foreground-400">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}